import { render, staticRenderFns } from "./ComplieRightMenuWork.vue?vue&type=template&id=825f344c&scoped=true"
import script from "./ComplieRightMenuWork.vue?vue&type=script&lang=js"
export * from "./ComplieRightMenuWork.vue?vue&type=script&lang=js"
import style0 from "./ComplieRightMenuWork.vue?vue&type=style&index=0&id=825f344c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825f344c",
  null
  
)

export default component.exports